"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendAsEpics = exports.loadSendAsEpic = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxObservable = require("redux-observable");

var _operators = require("rxjs/operators");

var _sendAs = require("./send-as.types");

var _sendAs2 = require("./send-as.actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var loadSendAsEpic = function loadSendAsEpic(action$, state$, _ref) {
  var createGiftService = _ref.createGiftService,
      errorHandler = _ref.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_sendAs.GIFT_CREATE_LOAD_SEND_AS_REQUEST), (0, _operators.mergeMap)(function (action) {
    // eslint-disable-next-line no-console
    console.log('update', _objectSpread({}, action.payload), action.payload.giftId);
    var request = typeof createGiftService.loadGiftSendAs === 'function' && action.payload.giftId ? createGiftService.loadGiftSendAs(action.payload.giftId) : createGiftService.loadSendAs(action.payload.teamId);
    return request.pipe((0, _operators.map)(function (response) {
      return (0, _sendAs2.loadSendAsSuccess)(response.users);
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _sendAs2.loadSendAsFail
    })));
  }));
};

exports.loadSendAsEpic = loadSendAsEpic;
var sendAsEpics = [loadSendAsEpic];
exports.sendAsEpics = sendAsEpics;